import React from 'react'
import { Badge } from 'reactstrap'
import RenderSpan from './RenderSpan'

const StatusCell = ({ cell, row, rowIndex }) => {
  const selectedOptions = {
    0: 'Active',
    1: 'Inactive',
    2: 'Ignored',
  }

  return (
    <span style={{ cursor: 'pointer' }}>
      <RenderSpan rowIndex={rowIndex} option={selectedOptions[cell]} ignoreReason={row.ignoreReason} />{' '}
      <Badge
        style={{
          float: 'right',
          marginRight: '20px',
          marginTop: '3px',
        }}
        color="secondary"
      >
        edit
      </Badge>
    </span>
  )
}

export default StatusCell
